type SentryClient = typeof import('@sentry/nextjs');

/**
 * Hand the browser Sentry SDK to `use`, loading it on demand so it stays out of
 * the first-load bundle.
 *
 * It owns its failures, so a caller never holds a promise. The SDK chunk can
 * fail to load (a deploy replaced it, a content blocker, a dropped connection),
 * and that is also a common reason an error boundary renders at all; `use` can
 * also throw (a failed `Sentry.init`, say). Left unhandled, either would
 * surface as a second, unreported error with nowhere to go; here both go to
 * the console.
 */
export function withSentry(use: (sentry: SentryClient) => void): void {
  import('@sentry/nextjs').then(use).catch((failure: unknown) => {
    console.error('[sentry] could not load or run the Sentry client', failure);
  });
}
